pmSectionItemsHaveData